export const hasSisterPermission = (permissions, permission) => Array.isArray(permission) ? permission.some(item => hasSisterPermission(permissions, item)) :
  Array.isArray(permissions) ? permissions.includes(permission) || permissions.includes("sister_company.*") :
  !!permissions && typeof permissions === "object" && (permissions[permission] === true || permissions["sister_company.*"] === true);
export const SISTER_PAGES = {
  companies: { title: "All Sister Companies", permission: "sister_company.view" },
  users: { title: "Users & Roles", permission: "sister_company.users.view" },
  dealers: { title: "Dealer Mapping", permission: "sister_company.dealers.view" },
  bookings: { title: "Company Bookings", permission: "sister_company.booking.view" },
  commissions: { title: "Commission Setup", permission: "sister_company.commission.configure" },
  dashboard: { title: "Finance Dashboard", permission: "sister_company.ledger.view" },
  ledger: { title: "Sister Company Ledger", permission: "sister_company.ledger.view" },
  expenses: { title: "Expense Ledger", permission: "sister_company.ledger.view" },
  "dealer-ledgers": { title: "Dealer Ledgers", permission: "sister_company.dealer_ledger.view" },
  "petty-cash": { title: "Petty Cash", permission: "sister_company.petty_cash.view" },
  payouts: { title: "Commission Payouts", permission: ["sister_company.commission.view", "sister_company.commission.payout"] },
  "bank-book": { title: "Bank Book", permission: "sister_company.bank_book.view" },
  reports: { title: "Reports", permission: "sister_company.reports.view" },
};
